import {
    defaultMarketResearchState,
    MarketResearchState,
    RelodeApiError,
} from "@relode/core";

import { JobPublicDetails } from "../../../../shared/types";

export type ClientPublicJobState = {
    ui: {
        selectedTab: string;
        fetchState: "loading" | "success" | "error" | "idle";
        error?: RelodeApiError;
    };
    data: {
        token: string;
        currentJobId: number;
        job: JobPublicDetails;
        marketResearch: MarketResearchState;
    };
};

export const defaultClientPublicJobState: ClientPublicJobState = {
    ui: {
        selectedTab: "insights",
        fetchState: "idle",
    },
    data: {
        token: undefined,
        currentJobId: undefined,
        job: undefined,
        marketResearch: defaultMarketResearchState,
    },
};
